import React from 'react';
 
import Popup from './CusPopup';

const ImgPopup = (props) => {

    const { popupTitle, popupValue, data } = props;
    const handleSetTrigger = () => {
        props.setTrigger();
    }

    return(
        <Popup className="popUpBox" trigger={popupValue} setTrigger={handleSetTrigger}>
            <div style={{ textAlign: "left" }} >
                <div className="bgBlack fbaPSize">
                    <div className="row">
                        <div className="col-11">
                            <div className="dcPgmh">{popupTitle}</div>
                        </div>
                    </div>
                </div>
                <div style={{paddingTop:'20px',textAlign:'center',maxHeight:640}} >
                    <img className="setImgPopupStyle" src={data} />
                </div>
            </div>
        </Popup>
    )
}

export default ImgPopup;